import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import React from "react";
/* eslint react/require-default-props: 0 */

/**
 * @private
 * This utility is only meant to wrap labels for Radio and Checkbox
 */

import classnames from 'classnames';
import shortid from 'shortid';

var withLabelWrapper = function withLabelWrapper(LabelComponent, wrapperConfigs) {
  return function (WrappedComponent) {
    return function (props) {
      var id = props.id,
          label = props.label,
          validation = props.validation,
          wrapperClasses = props.wrapperClasses,
          rest = _objectWithoutProperties(props, ["id", "label", "validation", "wrapperClasses"]);

      var classes = wrapperConfigs.classes,
          type = wrapperConfigs.type;
      var validationClass = validation ? "is-".concat(validation, "-input") : undefined;
      var htmlId = "".concat(type, "--").concat(id || shortid.generate());
      return React.createElement("div", {
        className: classnames(type, classes, wrapperClasses)
      }, React.createElement(WrappedComponent, _objectSpread({
        id: htmlId
      }, rest)), React.createElement(LabelComponent, {
        extraClasses: validationClass,
        htmlFor: htmlId,
        label: label,
        variation: type
      }));
    };
  };
};

export default withLabelWrapper;